export default __webpack_public_path__ + "static/calendar-view-ca8a96dba5cbf5d4b3ae7b9519d9ac6f.png";